import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import {
  closeEmbeddedMediaViewer,
  hasEmbeddedMediaViewerSession,
  isEmbeddedMediaViewerPathname,
  markEmbeddedMediaViewerSession
} from '@helpers/uxpEmbeddedMediaViewer';

export function UxpEmbeddedNavigationGuard() {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const { uxpHost } = window as unknown as {
      uxpHost?: { postMessage: (msg: object) => void };
    };
    if (!uxpHost) return;

    const isEmbeddedMediaViewer =
      isEmbeddedMediaViewerPathname(pathname) &&
      searchParams.get('embedded') === '1';

    if (isEmbeddedMediaViewer) {
      markEmbeddedMediaViewerSession();
      return;
    }

    if (!hasEmbeddedMediaViewerSession()) return;

    closeEmbeddedMediaViewer();
  }, [pathname, searchParams]);

  return null;
}
